import { FETCH_EMBED_CODE_SUCCEEDED } from '../actions/ActionTypes';
const initialState = '';
const embedCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMBED_CODE_SUCCEEDED:
      return action.payload;
    default:
      return state;
  }
};
export default embedCodeReducer;